import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Renderer2, ViewChild, AfterViewInit } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastService } from '@app/services/toast.service';
import { environment } from '@environments/environment.prod';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
interface Slides {
  image: string;
  title: string;
  description: string;
}
@Component({
  selector: 'app-logins',
  templateUrl: './logins.component.html',
  styleUrl: './logins.component.scss'
})
export class LoginsComponent implements AfterViewInit {
  @ViewChild('sliderWrapper') sliderWrapper!: ElementRef;

  //  loginForm!: FormGroup;
  submitted = false;
  showPassword = false;
  loginForm!: FormGroup;
  newPassword!: FormGroup;
  loading = false;
  isSubmitted = false;
  isSubmittedes = false;
  showError = false;

  orgEmail: string = '';
  orgDomain: string = '';
  orgName: string = '';
  orgPhone: string = '';
  city: string = '';

  isAnimate = false;
  disabledloginOtp = false;
  firstcity = false;

  resetPassword$!: Observable<any>;
  resetCity$!: Observable<any>;
  profile$!: Observable<any>;

  isPasswordVisible1 = false;
  isPasswordVisible3 = false;
  isPasswordVisible4 = false;

  // Modal visibility properties
  showChangePasswordModal = false;
  showCityModal = false;

  @ViewChild('myModal') myModal?: ElementRef;
  @ViewChild('myModals') myModals?: ElementRef;
  @ViewChild('changePasswordBackdrop') changePasswordBackdrop?: ElementRef;
  @ViewChild('cityBackdrop') cityBackdrop?: ElementRef;

  // Slider properties
  slides: Slides[] = [
    {
      image: '../../../../assets/images/banner_1.png',
      title: 'Track Every Delivery',
      description: 'Real-time GPS tracking for complete visibility'
    },
    {
      image: '../../../../assets/images/banner_2.png',
      title: 'Optimize Routes',
      description: 'AI-powered routing for faster deliveries'
    },
    {
      image: '../../../../assets/images/banner_3.png',
      title: 'Smart Analytics',
      description: 'Make data-driven decisions with insights'
    },
    {
      image: '../../../../assets/images/banner_4.png',
      title: 'Happy Customers',
      description: 'Deliver exceptional service every time'
    },
    {
      image: '../../../../assets/images/banner_5.png',
      title: 'Seamless Management',
      description: 'Centralized control for your entire fleet'
    }
  ];
  currentSlide = 0;
  slideInterval: any;
  isTransitioning = false;
  confirmPassword: boolean = false;
  // Touch/Swipe
  touchStartX = 0;
  touchEndX = 0;
  progress = 0;
  // Mouse drag
  isDragging = false;
  dragStartX = 0;
  isSubmitting = false;
  rememberedEmails: string[] = []; // Add this
  constructor(private fb: FormBuilder, private router: Router, public authService: AuthServiceService,
    private toastr: ToastrService, private toast: ToastService,
    private renderer: Renderer2, private sharedData: ShareddtaService) { }

  ngAfterViewInit(): void {
    this.sharedData.signalPageReady();
    this.startSlider();
  }

  ngOnInit(): void {
    const savedEmails = JSON.parse(localStorage.getItem('remembered_emails') || '[]');
    this.rememberedEmails = savedEmails;
    const lastEmail = savedEmails.length > 0 ? savedEmails[0] : '';

    this.orgEmail = lastEmail || this.authService.getOrgEmail || '';
    this.orgDomain = this.authService.getOrgDomain ?? '';
    this.orgName = this.authService.getLS('org_name') ?? '';
    this.orgPhone = this.authService.getLS('org_phone') ?? '';
    this.disabledloginOtp = this.orgPhone === 'Not Available'
    // Initialize login form
    this.loginForm = this.fb.group({
      email: [this.orgEmail, [Validators.required, Validators.pattern(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      )]],
      password: ['', [Validators.required]],
      organization_name: [{ value: this.orgName, disabled: true }, Validators.required]

    });
    this.newPassword = this.fb.group(
      {
        newPassword: ['', Validators.required],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: this.passwordMatchValidator
      }
    );

    // Start slider
    this.showSlide(0);
    this.startSlider();
    localStorage.setItem('isLoggedIn', 'false')
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.toast.show('error', 'Please fill in all required fields correctly');
      document.getElementById('email')?.focus();
      return;
    }
    this.isSubmitting = true;
    //this.openCityModal();
    // this.openChangePasswordModal();
    this.handleSubmit();
    //  console.log('Email:', this.loginForm.value.email);
    //  localStorage.setItem('isLoggedIn','true')
    //  this.router.navigate(['/admin/orders']);
  }

  // ---------------- Slider Methods ----------------

  showSlide(index: number, direction: 'next' | 'prev' = 'next') {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.progressInterval = setInterval(() => {
      this.progress += 2; // 100 / 50 steps = 2%

      if (this.progress >= 100) {
        this.progress = 100;
        clearInterval(this.progressInterval);
      }
    }, 100); //
    const prevIndex = this.currentSlide;
    this.currentSlide = index;

    setTimeout(() => {
      this.isTransitioning = false;
    }, 800);
  }

  nextSlide() {
    this.showSlide((this.currentSlide + 1) % this.slides.length, 'next');
    this.resetSlider();
  }

  prevSlide() {
    this.showSlide(
      (this.currentSlide - 1 + this.slides.length) % this.slides.length,
      'prev'
    );
    this.resetSlider();
  }
  progressInterval: any;
  startSlider() {
    clearInterval(this.slideInterval);
    this.slideInterval = setInterval(() => this.nextSlide(), 5000);
  }

  resetSlider() {
    clearInterval(this.slideInterval);
    this.startSlider();
  }

  // ---------------- Touch / Drag ----------------

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
  }

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.dragStartX = event.clientX;
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
  }

  onMouseUp(event: MouseEvent) {
    if (!this.isDragging) return;
    this.isDragging = false;

    const diff = this.dragStartX - event.clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) this.nextSlide();
      else this.prevSlide();
      this.resetSlider();
    }
  }

  onMouseLeave() {
    this.isDragging = false;
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) this.nextSlide();
      else this.prevSlide();
      this.resetSlider();
    }
  }

  // ---------------- Keyboard ----------------
  @HostListener('document:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') this.prevSlide();
    else if (event.key === 'ArrowRight') this.nextSlide();
  }

  // ---------------- Pause on Hover ----------------
  onMouseEnter() {
    clearInterval(this.slideInterval);
  }

  onMouseLeaveWrapper() {
    this.startSlider();
  }


  onKeyDown(event: KeyboardEvent) {
    this.submitted = false;
  }

  //  goBack() {
  //   this.router.navigate(['']);
  // }

  loginwithotp() {
    this.router.navigate(['/otp-verification']);
  }
  forgotpassword() {
    this.router.navigate(['/forgot-password']);
  }

  get f() { return this.loginForm.controls; }
  get n() { return this.newPassword.controls; }
  handleSubmit() {
    this.isSubmitted = true;
    if (this.loginForm.invalid) return;
    localStorage.setItem('firsttime', 'true');
    this.loading = true;
    const email = this.f['email'].value;
    // Save the email to history in localStorage
    let emails = JSON.parse(localStorage.getItem('remembered_emails') || '[]');
    emails = [email, ...emails.filter((e: string) => e !== email)].slice(0, 5);
    localStorage.setItem('remembered_emails', JSON.stringify(emails));
    this.rememberedEmails = emails;

    const deviceType = 'web';

    this.authService.login(email, this.f['password'].value, this.authService.getfcm_token(), deviceType)
      .subscribe(
        (data: any) => this.handleLoginSuccess(data),
        (error) => {
          this.isSubmitting = false;
          this.authService.dataError(error);
          this.loading = false;
        }
      );
  }
  handleLoginSuccess(data: any) {
    this.isSubmitting = false;
    this.loading = false;
    if (this.authService.resultCodeError(data)) return;

    if (data.subscription_status === 'expired') {
      this.authService.setLS('access_token', data.access_token);
      this.authService.setLS('OtpLogin', 'false');
      this.authService.setLS('subscription_status', data.subscription_status);
      this.toast.show('error', data?.actionPerformed);
      // this.checkSubscriptionStatus();
      return;
    }

    this.authService.setLS('is_first_login', data.is_first_login);
    this.authService.setLS('first_city_enter', data.first_city_enter);

    if (data.first_city_enter && data.is_first_login) {
      this.openChangePasswordModal();
    } else if (data.first_city_enter) {
      this.openCityModal();
    } else if (data.is_first_login) {
      this.openChangePasswordModal();
    } else {
      this.routeBasedOnRole(data);
    }
  }
  routeBasedOnRole(data: any) {
    const role = data.role?.[1];
    if (role === 'Organization Admin' || role === 'Super Admin') {
      this.saveAuthData(data);
      this.getProfile();

      const isShippedAdmin = data.is_shipped_admin;
      const isReceivingAdmin = data.is_receiving_admin;

      if (this.authService.getLS('is_first_login') === 'true') {
        this.router.navigate(['/login']);
        this.authService.setRetrievedData('false');
        this.openChangePasswordModal();
      } else {
        localStorage.setItem('isLoggedIn', 'true');
        this.authService._isDashboard.next(true);
        this.toast.show('success', data?.actionPerformed);

        if (isShippedAdmin && !isReceivingAdmin) {
          this.router.navigate(['/admin/dashboard']);
        } else if (isReceivingAdmin && !isShippedAdmin) {
          this.router.navigate(['/receiving-admin/orders']);
          window.location.reload();
        } else {
          // Default fallback
          this.router.navigate(['/admin/dashboard']);
        }
      }
    } else {
      this.toast.show('error', 'Access not allowed');
      this.clearOrgLocalStorage();
      this.router.navigate(['/']);
    }
  }
  saveAuthData(data: any) {
    this.authService.setLS('access_token', data.access_token);
    this.authService.setLS('refresh_token', data.refresh_token);
    this.authService.setLS('name', data.name);
    this.authService.setLS('user_timezone', data.user_timezone);
    this.authService.setLS('is_shipped_admin', data.is_shipped_admin);
    this.authService.setLS('is_receiving_admin', data.is_receiving_admin);
    this.authService.setLS('plan_category', data.plan_category);
    const role = data.role; // e.g., [2, "Organization Admin"]
    const isShippedAdmin = data.is_shipped_admin;
    const isReceivingAdmin = data.is_receiving_admin;
    const plan_category = data?.plan_category
    // Conditional role logic
    // 🔥 Highest priority — if plan category is receiving → always Customer
    if (plan_category === 'receiving') {
      this.authService.setLS('role', [3, 'Customer']);
    }

    // 🔽 Existing logic runs ONLY when above condition doesn't trigger
    else if (
      (isShippedAdmin && isReceivingAdmin) ||
      (!isShippedAdmin && !isReceivingAdmin) ||
      (isShippedAdmin && !isReceivingAdmin)
    ) {
      this.authService.setLS('role', role);
    }

    else if (!isShippedAdmin && isReceivingAdmin) {
      this.authService.setLS('role', [3, 'Receiving Admin']);
    }

  }
  clearOrgLocalStorage() {
    ['org_email', 'org_name', 'org_Id', 'org_domain', 'org_phone'].forEach(key => localStorage.removeItem(key));
  }
  companyName: string = localStorage.getItem('org_name') || localStorage.getItem('compname') || 'RealTimeTrac';
  getProfile() {
    // this.profile$ = this.authService.getProfile();
    // this.profile$.subscribe((data: any) => {
    //   const roleId = parseInt(localStorage.getItem('role')?.split(',')[0] || '0');
    //   const id = roleId === 1 ? data?.result?.id : data?.result?.admin?.id;
    //   localStorage.setItem('notifId', id);
    //   if (roleId === 2) {
    //     localStorage.setItem('is_superuser', data.result.admin.is_superuser);
    //     localStorage.setItem('is_staff', data.result.admin.is_staff);
    //     localStorage.setItem('logo', data.result.organization.company.logo);
    //      localStorage.setItem('require_delivery_signature', data.result.organization.company.require_delivery_signature);
    //      localStorage.setItem('organizationaddress', data.result.warehouse.address.address);
    //   }
    // });
  }

  goBack(event: Event) {
    event.preventDefault();
    // Preserve remembered emails, clear everything else
    const preserved = ['remembered_emails'];
    Object.keys(localStorage).forEach(key => {
      if (!preserved.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    this.router.navigate(['/']);
  }

  passwordMatchValidator(group: FormGroup) {
    const password = group.get('newPassword')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  newpassword() {
    this.isSubmittedes = true;
    const data = `${this.orgDomain}:${environment.port}`;
    this.authService.sendDataToAuthService(data);

    if (this.newPassword.valid) {
      this.resetPassword$ = this.authService.resetPasswords(this.f['email'].value, this.n['newPassword'].value);
      this.resetPassword$.subscribe(
        () => this.toast.show('success', 'Password has been updated successfully!'),
        () => this.toast.show('error', "Failed to update the password"),
      );
    }
  }


  // ========== CHANGE PASSWORD MODAL METHODS ==========
  showNewPassword = false;
  showConfirmPassword = false;

  toggleNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }
  toggleConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  openChangePasswordModal() {
    this.showChangePasswordModal = true;
  }

  closeChangePasswordModal() {
    this.showChangePasswordModal = false;
    this.isSubmitting = false;
  }

  onChangePasswordConfirm() {
    if (this.newPassword.invalid) {
      this.isSubmittedes = true;
      return;
    }
    this.newpassword();
    this.isSubmitting = false;
    const firstCityData = JSON.parse(localStorage.getItem('first_city_enter') || 'false');
    if (firstCityData === true) {
      this.openCityModal();
      this.closeChangePasswordModal();
    } else {
      this.closeChangePasswordModal();
      this.router.navigate(['/login']);
      this.authService.setRetrievedData('true');
    }
    // this.closeChangePasswordModal();

  }

  // ========== CITY MODAL METHODS ==========
  openCityModal() {
    this.showCityModal = true;
    this.showError = false;
    this.city = '';
  }

  closeCityModal() {
    this.showCityModal = false;
    this.showError = false;
    this.city = '';
    this.isSubmitting = false;
  }

  onCityConfirm() {
    if (!this.city.trim()) {
      this.showError = true;
      return;
    }
    const data = `${this.orgDomain}:${environment.port}`;
    this.authService.sendDataToAuthService(data);

    this.resetCity$ = this.authService.addCity(this.f['email'].value, 'false', this.city);
    this.resetCity$.subscribe(
      () => {
        this.toast.show('success', "City has been updated successfully!");
        this.closeCityModal();
        this.router.navigate(['/login']);
      },
      () => this.toast.show('error', "Failed to add the city"),
    );
    this.isSubmitting = false;
    this.authService.setRetrievedData('true');
  }
  onCityChange() {
    if (this.city && this.city.trim().length > 0) {
      this.showError = false;
    }
  }
}
